/**
 * Loopback and public tunnels use a relative URL so the session cookie stays
 * same-origin. localhost and 127.0.0.1 are different sites; a cookie set on
 * one is not sent to the other (SameSite=Lax).
 * Any other host (Tailscale IP or MagicDNS) uses the same host on the API port.
 */
export function resolveApiBaseUrl(
  hostname: string,
  configured: string,
  protocol: string = 'http:'
): string {
  if (isPublicTunnel(hostname) || isLoopback(hostname)) {
    return '';
  }

  const port = portFromUrl(configured) ?? '8080';
  const host = hostname.includes(':') ? `[${hostname}]` : hostname;
  const scheme = protocol === 'https:' ? 'https' : 'http';
  return `${scheme}://${host}:${port}`;
}

function isPublicTunnel(hostname: string): boolean {
  return (
    hostname === 'commpare.app' ||
    hostname.endsWith('.commpare.app') ||
    hostname.endsWith('.trycloudflare.com') ||
    hostname.endsWith('.ngrok-free.app') ||
    hostname.endsWith('.ngrok.io') ||
    hostname.endsWith('.loca.lt')
  );
}

function isLoopback(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

function portFromUrl(url: string): string | undefined {
  try {
    const parsed = new URL(url);
    return parsed.port || undefined;
  } catch {
    return undefined;
  }
}
